(function() {
  'use strict';
  angular.module('common')
  .directive('button', ['$window', '$timeout', function($window, $timeout) {
    return {
      link: function($scope, element, attrs) {
        if (attrs.type && attrs.type.toLowerCase() === 'reset') {
          let handler = function() {
            $timeout(function() {
              $($window).scrollTop(0);
            });
          };
          element.on('click', handler);
          $scope.$on('$destroy', function() {
            element.off('click', handler);
          });
        }
      }
    };
  }]);
})();